var pug = require("!../../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (ngRequired, required) {pug_mixins["centered-content"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "centered-content","layout": "row"},attributes]), true)) + "\u003E\u003Cdiv class=\"content\" layout=\"column\" layout-align=\"start stretch\" flex flex-md=\"90\" flex-lg=\"80\" flex-gt-lg=\"70\" flex-offset-md=\"5\" flex-offset-lg=\"10\" flex-offset-gt-lg=\"15\"\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
pug_mixins["contentful-component"] = pug_interp = function(component){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-if", "" + component + ".fields.type === 'wide'", true, true)) + "\u003E\u003Cicon-panel" + (" class=\"wide-panel\""+pug.attr("panel", "" + component, true, true)) + "\u003E\u003C\u002Ficon-panel\u003E\u003C\u002Fdiv\u003E";
pug_mixins["centered-content"].call({
block: function(){
pug_html = pug_html + "\u003Cicon-panel" + (" class=\"standard-panel\""+pug.attr("panel", "" + component, true, true)) + "\u003E\u003C\u002Ficon-panel\u003E";
},
attributes: {"ng-if": pug.escape("" + component + ".fields.type !== 'wide'")}
});
};





























pug_mixins["required-radio-container"] = pug_interp = function(name, model, layout){
var block = (this && this.block), attributes = (this && this.attributes) || {};
ngRequired = attributes['ng-required']
required = !ngRequired
layout = layout || 'row'
pug_html = pug_html + "\u003Cmd-radio-group" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("ng-model", model, true, true)+pug.attr("layout", layout, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003Chelp-mate" + (pug.attr("topic", name, true, true)) + "\u003E\u003C\u002Fhelp-mate\u003E\u003C\u002Fmd-radio-group\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("required", required, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E";
};
pug_mixins["required-yes-no"] = pug_interp = function(name, model){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_mixins["required-radio-container"].call({
block: function(){
pug_html = pug_html + "\u003Cmd-radio-button value=\"Yes\"\u003EYes\u003C\u002Fmd-radio-button\u003E\u003Cmd-radio-button value=\"No\"\u003ENo &nbsp;&nbsp;\u003C\u002Fmd-radio-button\u003E";
}
}, name, model);
};
pug_mixins["required-select"] = pug_interp = function(name, model, label){
var block = (this && this.block), attributes = (this && this.attributes) || {};
label = label || name
pug_html = pug_html + "\u003Cinput-container" + (pug.attr("label", label, true, true)) + "\u003E\u003Cmd-select" + (" class=\"required-select big-list\""+pug.attr("ng-model", model, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)+pug.attr("placeholder", label, true, true)+pug.attr("aria-label", label, true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fmd-select\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("required", true, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E\u003C\u002Finput-container\u003E";
};










































































pug_mixins["rateDisplay"] = pug_interp = function(rate){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + (pug.escape(null == (pug_interp = rate) ? "" : pug_interp)) + "\u003Cimg src=\"\u002Ficons\u002Ficon-percent-pa.svg\" alt=\"percentage pa\"\u003E";
};












pug_html = pug_html + "\u003Cdiv ng-if=\"'partnership' !== vm.businessType\"\u003E";
pug_mixins["required-radio-container"].call({
block: function(){
pug_html = pug_html + "\u003Cmd-radio-button value=\"beneficialOwner\"\u003EBeneficial Owner\u003C\u002Fmd-radio-button\u003E\u003Cmd-radio-button value=\"director\"\u003EDirector\u003C\u002Fmd-radio-button\u003E\u003Cmd-radio-button value=\"beneficialOwnerAndDirector\"\u003EBeneficial owner and director\u003C\u002Fmd-radio-button\u003E";
}
}, "representativeType", "vm.representative.type", "column");
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"'true'===vm.showAppointer\" flex layout=\"row\" layout-align=\"start center\"\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cdiv layout=\"row\" layout-align=\"none top\"\u003E\u003Cinput-container label=\"{{vm.percentagePrompt}}\" flex\u003E\u003Cinput required name=\"representativeOwnershipPercent\" ng-model=\"vm.representative.ownershipPercent\" type=\"number\" min=\"0\" max=\"100\"\u003E\u003C\u002Finput-container\u003E\u003Cp\u003E%\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cinput-container label=\"First name\"\u003E\u003Cinput required name=\"firstName\" ng-model=\"vm.representative.firstName\"\u003E\u003C\u002Finput-container\u003E\u003Cinput-container label=\"Middle name\"\u003E\u003Cinput name=\"middleName\" ng-model=\"vm.representative.middleName\"\u003E\u003C\u002Finput-container\u003E\u003Cinput-container label=\"Last name\"\u003E\u003Cinput required name=\"lastName\" ng-model=\"vm.representative.lastName\"\u003E\u003C\u002Finput-container\u003E\u003Cinput-container label=\"Email address\"\u003E\u003Cinput required name=\"email\" ng-model=\"vm.representative.email\" type=\"email\"\u003E\u003C\u002Finput-container\u003E\u003Cdiv layout=\"row\" layout-align=\"start center\"\u003E\u003Cp\u003EDoes he\u002Fshe have a day-to-day role in the business? &nbsp;&nbsp;\u003C\u002Fp\u003E";
pug_mixins["required-yes-no"]("hasActiveRoleInBusiness", "vm.representative.hasActiveRole");
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"vm.representative.hasActiveRole === 'Yes'\"\u003E\u003Cinput-container label=\"Job title \u002F role\"\u003E\u003Cinput name=\"jobTitle\" ng-model=\"vm.representative.jobTitle\"\u003E\u003C\u002Finput-container\u003E\u003C\u002Fdiv\u003E";}.call(this,"ngRequired" in locals_for_with?locals_for_with.ngRequired:typeof ngRequired!=="undefined"?ngRequired:undefined,"required" in locals_for_with?locals_for_with.required:typeof required!=="undefined"?required:undefined));;return pug_html;};
module.exports = template;